(function () {
  function updateSetNote() {
    const note = document.querySelector(".revel-set-note");
    if (!note) return;

    const checkedInput = document.querySelector('input[type="radio"]:checked');
    const selectedText =
      checkedInput?.value ||
      checkedInput?.nextElementSibling?.textContent ||
      "";

    note.hidden = !selectedText.toLowerCase().includes("set");
  }

  function initStickyAddToCart() {
    const sticky = document.querySelector(".revel-mobile-sticky-atc");
    const stickyButton = document.querySelector(".revel-mobile-sticky-atc__button");
    const stickyPrice = document.querySelector(".revel-mobile-sticky-atc__price");

    const mainButton =
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]');

    const priceWrapper = document.querySelector(".product__info-wrapper .price");

    if (!sticky || !stickyButton || !mainButton) return;

    function syncStickyButton() {
      stickyButton.disabled = mainButton.disabled;

      const mainButtonText = mainButton.textContent.trim();
      if (mainButtonText) {
        stickyButton.textContent = mainButtonText;
      }
    }

    function syncStickyPrice() {
  if (!stickyPrice) return;

  const checkedInput = document.querySelector('input[type="radio"]:checked');
  const selectedText =
    checkedInput?.value ||
    checkedInput?.nextElementSibling?.textContent ||
    "";

  if (selectedText.toLowerCase().includes("set")) {
    stickyPrice.textContent = "€69,90";
  } else {
    stickyPrice.textContent = "€39,90";
  }
}

    stickyButton.addEventListener("click", function () {
      mainButton.click();
    });

    syncStickyButton();
    syncStickyPrice();

    const buttonObserver = new MutationObserver(function () {
      syncStickyButton();
    });

    buttonObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    if (priceWrapper) {
      const priceObserver = new MutationObserver(function () {
        syncStickyPrice();
      });

      priceObserver.observe(priceWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    const visibilityObserver = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];

        if (window.innerWidth > 749) {
          sticky.classList.remove("is-visible");
          sticky.setAttribute("aria-hidden", "true");
          return;
        }

        if (entry.isIntersecting) {
          sticky.classList.remove("is-visible");
          sticky.setAttribute("aria-hidden", "true");
        } else {
          sticky.classList.add("is-visible");
          sticky.setAttribute("aria-hidden", "false");
        }
      },
      {
        threshold: 0
      }
    );

    visibilityObserver.observe(mainButton);
  }

  document.addEventListener("change", function (event) {
  if (event.target.matches('input[type="radio"]')) {
    updateSetNote();

    setTimeout(function () {
      initStickyAddToCart();
    }, 100);
  }
});

  document.addEventListener("DOMContentLoaded", function () {
    updateSetNote();
    initStickyAddToCart();
  });
})();